import Handlebars from 'handlebars';

import AssetAttachmentsTemplate from 'templates/AssetAttachments.handlebars';
import CollectionAttachmentsTemplate from 'templates/CollectionAttachment.handlebars';
import CollectionCTATemplate from 'templates/CollectionCTA.handlebars';
import CollectionLinkTemplate from 'templates/CollectionLink.handlebars';

import _ from 'lodash';

import { ASSETS_TABLE_WIDGET, LINK_WIDGET, BUTTON_WIDGET  } from 'constants/widgetTypes';
import buildUrl from 'build-url';

Handlebars.registerHelper('helperMissing', function() {
  var options = arguments[arguments.length - 1];
  return 'MISSING VALUE: ' + options.name;
}); 

Handlebars.registerHelper('placeholder', function(value, placeholder) {
  if(value !== undefined){
    return value;
  }

  var result = '<span class="placeholder">' + placeholder + '</span>';
  return new Handlebars.SafeString(result);
}); 

export default class CollectionWidgetManager{
  constructor() {
    this.widgets = [{
      id: ASSETS_TABLE_WIDGET,
      name: 'Asset Table',
      icon: '/images/widgets/table.svg',
      description: 'Insert assets as a table of attachments',
      render: (parameters) => {
        var html = "";

        parameters = this.processParameters(parameters);
        
        if(parameters.collection !== null){
          html =  CollectionAttachmentsTemplate(parameters);
        }else if(parameters.assets.length > 0){
          html =  AssetAttachmentsTemplate(parameters);
        }

        return html;
      }
    },{
      id: BUTTON_WIDGET,
      name: 'Content Button',
      icon: '/images/widgets/button.svg',
      description: 'Insert the content as a CTA',
      render: (parameters) => {
        parameters = this.processParameters(parameters);
        
        var html =  CollectionCTATemplate(parameters);
        
        return html;
      }
    },{
      id: LINK_WIDGET,
      name: 'Content Link',
      icon: '/images/widgets/link.svg',
      description: 'Insert the content as a link',
      render: (parameters) => {
        parameters = this.processParameters(parameters);
        
        var html =  CollectionLinkTemplate(parameters);
        
        return html;
      }
    }];
  }

  widgets(){
   return this.widgets;
  }

  widget(id){
    return this.widgets.find((item) => {
      return item.id == id;
    })  
  }

  prepareUtmLink(item, utmCampaign) {
    var utmLink = item.link;
    var queryParams = {};

    if (utmCampaign !== null) {
      const filteredObject = _.pickBy(utmCampaign, value => !_.isEmpty(value));
      let utmCampaignParams = _.omitBy(filteredObject, _.isNil);
      _.forOwn(utmCampaignParams, (value, key) => {
        queryParams[`utm_${key}`] = value

      })

      utmLink = buildUrl(utmLink, {
        queryParams: queryParams
      })
    }
    return utmLink;
  }

  processParameters(request){
    if(request.collection){
      var icon = _.get(request.collection, 'banner.background.thumbnail');
      if(!icon){
        icon = `${process.env.REACT_APP_WEBAPP_URL}/images/email/default_asset.jpg`;
      }

      var collectionLink = _.get(request,"collection.link")
      if (_.get(request, "activeCRM", "") === "GMAIL")
      {
        collectionLink = this.prepareUtmLink(request.collection, _.get(request,"settings.utmCampaign"));
      }
  
      request = {
        ...request,
        collection: {
          ...request.collection,
          icon: icon,
          link: collectionLink
        },
        link: collectionLink
      }
    }else if (request.assets){
      var assets = (request.assets || []).map(item => {
        var icon = _.get(item, 'icon.thumbnail');
        if(!icon){
          icon = `${process.env.REACT_APP_WEBAPP_URL}/images/email/default_asset.jpg`;
        }

        var assetLink = _.get(item,"link")
        if (_.get(request, "activeCRM", "") === "GMAIL")
        {
          assetLink = this.prepareUtmLink(item, _.get(request,"settings.utmCampaign"));
        }

        return {
          ...item,
          icon: icon,
          link: assetLink
        }
      })
  
      request = {
        ...request,
        assets: assets,
        link: assets[0].link
      }
    }

    return request;
  }
}